import React from "react";
import { Link } from "react-router-dom";

const Packages = () => {
  return (
    <div className="packages-section-wrapper">
      <div className="packages-bg-overlay">
         <img src="/PackzdfdfagedB.png" alt="Background Texture" />
      </div>

      <img src="/PackagedL.png" className="floral-bg left" alt="" />
      <img src="/PackagedR.png" className="floral-bg right" alt="" />

      <div className="container py-5 content-relative">
        <div className="text-center mb-5">
          <h2 className="journey-title">
            Everything Your Journey Needs, <br />
            Perfectly <span className="pink-text">Packaged.</span>
          </h2>
          <p className="journey-subtitle mx-auto">
            We’ve replaced the hidden costs and confusing hospital bills with complete
            transparency. Experience the future of pregnancy care risk-free, or dive straight into our
            all-inclusive sanctuary designed for your absolute peace of mind.
          </p>
        </div>

        <div className="row g-4 justify-content-center">
          <div className="col-lg-5 col-md-6">
            <div className="package-card hover-lift">
              <div className="card-image-box">
                <img src="/Packaged1.png" alt="Discovery" className="img-fluid" />
              </div>
              <div className="card-body-content">
                <h3 className="card-package-name">The Discovery Experience</h3>
                <div className="price-tag">
                  <span className="currency">₹</span>0 <small>(Complimentary 7-Day Access)</small>
                </div>
                <ul className="package-features-list">
                  <li><i className="bi bi-check2-circle"></i> 7-Day Platform Access</li>
                  <li><i className="bi bi-check2-circle"></i> Daily Garbhasanskar</li>
                  <li><i className="bi bi-check2-circle"></i> 24/7 Emergency Support</li>
                  <li><i className="bi bi-check2-circle"></i> End-to-End Taste</li>
                </ul>
                <Link to="/elemental-care" className="btn-package btn-solid">
                  Experience It For Free
                </Link>
              </div>
            </div>
          </div>

          <div className="col-lg-5 col-md-6">
            <div className="package-card featured-card hover-lift">
              <div className="card-image-box">
                <img src="/Packaged2.png" alt="Signature Care" className="img-fluid" />
              </div>
              <div className="card-body-content">
                <h3 className="card-package-name">The Signature Care Ecosystem</h3>
                <div className="price-tag">
                  <span className="currency">₹</span>7,777 <small>/ Month</small>
                </div>
                <ul className="package-features-list">
                  <li><i className="bi bi-check2-circle"></i> Dedicated Circle of 9 Experts</li>
                  <li><i className="bi bi-check2-circle"></i> 44+ Doctor Consultations</li>
                  <li><i className="bi bi-check2-circle"></i> 9 Ultrasound Scans</li>
                  <li><i className="bi bi-check2-circle"></i> 40+ Lab Tests</li>
                  <li><i className="bi bi-check2-circle"></i> AI Daily Health Tracking</li>
                  <li><i className="bi bi-check2-circle"></i> 24x7 Emergency Support</li>
                  <li><i className="bi bi-check2-circle"></i> Personalized Diet Plans</li>
                  <li><i className="bi bi-check2-circle"></i> Prenatal Yoga Sessions</li>
                  <li><i className="bi bi-check2-circle"></i> Mental Health Coaching</li>
                  <li><i className="bi bi-check2-circle"></i> Daily Garbhasanskar</li>
                  <li><i className="bi bi-check2-circle"></i> Parenting Masterclasses</li>
                  <li><i className="bi bi-check2-circle"></i> Monthly Care Reviews</li>
                  <li><i className="bi bi-check2-circle"></i> WhatsApp Gynecologist Access</li>
                  <li><i className="bi bi-check2-circle"></i> Pregnancy Care Kit</li>
                  <li><i className="bi bi-check2-circle"></i> Monthly Surprise Hampers</li>
                  <li><i className="bi bi-check2-circle"></i> End-to-End Digital Care</li>
                </ul>
                <Link to="/pricing" className="btn-package btn-solid">
                  Explore The Signature Plan
                </Link>
              </div>
            </div>
          </div>
        </div>

        <p className="text-center mt-5 footer-quote">
          Because every mother deserves the right care at the right time
        </p>
      </div>
    </div>
  );
};

export default Packages;